import React from 'react';
import {Route, Switch as RouterSwitch, useRouteMatch} from 'react-router-dom';
import MainFrame from "../../mainframe/MainFrame";
import {ServicesScreen} from "../services/Services.screen";
import {Button, Typography} from "@material-ui/core";
import {ExitToApp} from "@material-ui/icons";
import {WorkersFeature} from "../workers/Workers.feature";
import {useInitializeServices} from "../services/redux/services.hook";
import {useLogout} from "../../auth/redux/auth.hook";
import {AdminsFeature} from "../admins/Admins.feature";
import {ClientsFeature} from "../clients/Clients.feature";
import {OrdersFeature} from "../orders/Orders.feature";
import {WorkersCalendar} from "../calendar/WorkersCalendar";
import {FirebaseAuthConsumer} from "@react-firebase/auth";
import {Skeleton} from "@material-ui/lab";
import {InitialChangePassword} from "../workerApp/InitialChangePassword";

export function AdminApp() {

    useInitializeServices();
    const {logout} = useLogout();
    const {path} = useRouteMatch();

    return (<InitialChangePassword>
            <MainFrame>

                <RouterSwitch>
                    <Route path={`${path}/workers`}>
                        <WorkersFeature/>
                    </Route>
                    <Route path={`${path}/admins`}>
                        <AdminsFeature/>
                    </Route>
                    <Route path={`${path}/clients`}>
                        <ClientsFeature/>
                    </Route>
                    <Route path={`${path}/orders`}>
                        <OrdersFeature/>
                    </Route>
                    <Route path={`${path}/services`}>
                        <ServicesScreen/>
                    </Route>
                    <Route path={`${path}/settings`}>
                        <Typography>Logged in as:</Typography>
                        <Typography variant="h6" color="secondary" style={{marginTop: 24, marginBottom: 24}}>
                            <FirebaseAuthConsumer>
                                {({isSignedIn, user}) => (
                                    isSignedIn ? user.email : <Skeleton width={80}/>
                                )}
                            </FirebaseAuthConsumer>
                        </Typography>
                        <Button
                            startIcon={<ExitToApp/>}
                            variant="contained"
                            color="primary"
                            onClick={logout}
                        >
                            logout
                        </Button>
                    </Route>
                    <Route path={`${path}/calendar`}>
                        <WorkersCalendar/>
                    </Route>
                    <Route path='*' exact component={() => (<div>route not found</div>)}/>
                </RouterSwitch>
            </MainFrame>
        </InitialChangePassword>
    )
}
